import { React, useState, useEffect } from "react";
import request from "../../../Helpers/API";
import {
    Modal,
    TextField,
    Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import SaveIcon from '@mui/icons-material/Save';

export const JustificacionPiezasModal = ({ open, onClose, id_inv, descripcion, verResultado }) => {

    const [piezasJustificadas, setPiezasJustificadas] = useState("");
    const [justificacion, setJustificacion] = useState("");

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleClose = () => {
        onClose();
    };

    const titulo = "Justificación de piezas";

    useEffect(() => {
        if (!open || !id_inv) return;
        GetJustificacion(id_inv);
    }, [open, id_inv]);


    const GetJustificacion = (
        id_inv
    ) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`RealizarConteo/GetJustificacion?id_inv_fisico=${id_inv}`)
                .then((result) => {
                    setPiezasJustificadas(result.justificadas);
                    setJustificacion(result.justificacion);

                    setLoader({ ...loader, mostrar: false });
                    return;
                })
                .catch((error) => {

                    const mensaje =
                        error?.response?.data ||
                        error?.Mensaje ||
                        "Error al cargar la justificacion.";
                    Swal.fire("Justificacion", mensaje, "error");
                    setLoader({ ...loader, mostrar: false });
                    return;
                });
        });
    };

    const onJustificar = async (id, justificadas, justificacion) => {
        try {

            const piezas = Number(justificadas);

            if (!piezas || piezas <= 0) {
                Swal.fire(
                    "Justificación",
                    "Debe capturar la cantidad de piezas justificadas.",
                    "warning"
                );
                return;
            }

            if (!justificacion || justificacion.trim() === "") {
                Swal.fire(
                    "Justificación",
                    "Debe escribir la justificación.",
                    "warning"
                );
                return;
            }

            setLoader({ ...loader, mostrar: true });

            const post = {
                id_inv_fisico: id,
                justificadas: justificadas,
                justificacion: justificacion
            };

            await request.post("RealizarConteo/Justificar", post);

            setLoader({ ...loader, mostrar: false });

            await Swal.fire({
                title: "JUSTIFICACION",
                text: "Justificación aplicada con éxito",
                icon: "success",
            });

            onClose();

        } catch (error) {

            setLoader({ ...loader, mostrar: false });

            Swal.fire(
                "JUSTIFICACION",
                JSON.stringify(error?.response?.data || error),
                "error"
            );
        }
    };

    const textFieldStyles = {
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#f9f9f9",
            fontSize: "13px",

            "& fieldset": {
                borderColor: "#e0e0e0",
            },

            "&:hover fieldset": {
                borderColor: "#bdbdbd",
            },

            "&.Mui-focused fieldset": {
                borderColor: "#2e7d32",
                borderWidth: "1px",
            },
        },

        "& .MuiInputBase-input": {
            color: "#555",
            // padding: "8px 12px",

            "&::placeholder": {
                color: "#aaa",
                opacity: 1,
            },
        },
    };

    return (
        <>
            <LoaderScreen loader={loader} />

            <Modal open={open} onClose={onClose}>
                <div className="justificar-pieza-conteo-modal-formulario">

                    <div className="justificar-pieza-conteo-modal-plantilla">

                        <div
                            className="justificar-pieza-conteo-container"
                            id="mdlFiltros-modal"
                        >

                            <PlantillaScreen
                                titulo={titulo}
                                className_main={1}
                                className={"justificar-pieza-conteo-container-modal"}
                            >

                                <div
                                    className="cerrar-modal-button"
                                    onClick={handleClose}
                                >
                                    X
                                </div>

                                <div className={`justificar-pieza-conteo-modal`}>

                                    <div
                                        className="justificar-pieza-conteo-modal-container"
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "18px",
                                            padding: "10px 5px",
                                        }}
                                    >

                                        {/* PIEZAS JUSTIFICADAS */}
                                        <div>
                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    marginBottom: "6px",
                                                    color: "#555",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Número de piezas justificadas
                                            </Typography>

                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                type="text"
                                                disabled={verResultado}
                                                value={piezasJustificadas}
                                                onChange={({ target }) => {
                                                    let value = target.value;

                                                    // solo números y punto
                                                    value = value.replace(/[^0-9.]/g, "");

                                                    // solo un punto
                                                    const parts = value.split(".");
                                                    if (parts.length > 2) {
                                                        value = parts[0] + "." + parts[1];
                                                    }

                                                    setPiezasJustificadas(value);
                                                }}
                                                placeholder="Ingrese la cantidad"
                                                sx={textFieldStyles}
                                            />
                                        </div>

                                        {/* JUSTIFICACION */}
                                        <div>
                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    marginBottom: "6px",
                                                    color: "#555",
                                                    fontWeight: 500,
                                                }}
                                            >
                                                Justificación
                                            </Typography>

                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                multiline
                                                rows={5}
                                                value={justificacion}
                                                disabled={verResultado}
                                                onChange={({ target }) =>
                                                    setJustificacion(target.value)
                                                }
                                                placeholder="Escriba la justificación..."
                                                sx={textFieldStyles}
                                            />
                                        </div>

                                    </div>

                                    <div className="justificar-pieza-conteo-modal-buttons">

                                        {!verResultado && (
                                            <button className="pa-btn pa-btn--primary"
                                                onClick={() => onJustificar(id_inv, piezasJustificadas, justificacion)}
                                            >
                                                <SaveIcon style={{ fontSize: 18 }} />
                                                Guardar
                                            </button>
                                        )}
                                    </div>

                                </div>

                            </PlantillaScreen>

                        </div>

                    </div>

                </div>
            </Modal>
        </>
    );
};